/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CategoryOverviewList } from '../../models/category-overview-list';

export interface ApiCategoryOverviewGet$Params {

/**
 * #### String with a list of sort fields separated by `|`. Prepend a `+` or `-` symbol to indicate the sorting method. Example:  `+address|-name|-year`
 */
  sort?: string;

/**
 * #### Page number to retrieve. First page is 0
 */
  page?: number;

/**
 * #### Number of results to return. Default is no limit
 */
  limit?: number;

/**
 * #### List of filters to apply to the query. Each filter is a string in the format:'{"field":"field_name", "operator":"operator_name", "value":"str/number"}'
 */
  filter?: Array<string>;

/**
 * #### List of filters to apply to the query. Each filter is a string in the format:'{"field":"field_name", "operator":"operator_name", "value":"str/number"}'
 */
  filter_or?: Array<string>;

/**
 * #### Apply permissions
 */
  apply_permissions?: string;
}

export function apiCategoryOverviewGet(http: HttpClient, rootUrl: string, params?: ApiCategoryOverviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryOverviewList>> {
  const rb = new RequestBuilder(rootUrl, apiCategoryOverviewGet.PATH, 'get');
  if (params) {
    rb.query('sort', params.sort, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter', params.filter, {"style":"form","explode":true});
    rb.query('filter_or', params.filter_or, {"style":"form","explode":true});
    rb.query('apply_permissions', params.apply_permissions, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CategoryOverviewList>;
    })
  );
}

apiCategoryOverviewGet.PATH = '/api/category/overview';
